<div class="modal-header d-flex justify-content-between align-items-center border-bottom-0 pb-0" style="background: #1e1e1e;">
    <h4 class="modal-title" style="color: #ffffff; font-weight: 700;">
      <i class="fa-solid fa-envelope me-2" style="color: #00a8ff;"></i> Reset Password
    </h4>
    <button type="button" class="close-btn" (click)="modalRef.hide()">
      <i class="fa-solid fa-xmark"></i>
    </button>
</div>

<div class="modal-body pb-4" style="background: #1e1e1e; color: #e0e0e0;">
  <p class="mb-4" style="color: rgba(255, 255, 255, 0.7); font-size: 14px;">
    Enter your registered email address below, and we'll send you a secure link to reset your password.
  </p>

  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="mb-3">
      <label class="form-label mb-2" style="color: #ffffff; font-weight: 500;">Email Address</label>
      <input
        type="email"
        class="form-control"
        style="background: rgba(255, 255, 255, 0.05); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px; color: #ffffff; padding: 10px 15px;"
        formControlName="email"
        placeholder="e.g., example@email.com"
        autocomplete="email"
      />
      @if (form.get('email')?.invalid && form.get('email')?.touched) {
        <small style="color: #ff6b6b;" class="mt-1 d-block">Please enter a valid email address.</small>
      }
    </div>

    <div class="d-flex justify-content-center gap-3 mt-4">
      <button
        type="submit"
        class="btn modern-btn primary-btn"
        style="min-width: 330px; height: 42px;"
        [disabled]="form.invalid || isSubmitting"
      >
        @if (isSubmitting) { <span class="spinner-border spinner-border-sm me-2"></span> }
        {{ isSubmitting ? 'Sending...' : 'Send Reset Link' }}
      </button>
      <button type="button" class="btn modern-btn secondary-btn" style="min-width: 120px;" (click)="modalRef.hide()">
        Cancel
      </button>
    </div>
  </form>
</div>
